import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GrainIcon from "@mui/icons-material/Grain";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import BadgeIcon from "@mui/icons-material/Badge";
import SchoolIcon from "@mui/icons-material/School";


export const menus = [
  {
    name: "Home",
    icon: HomeIcon,
    link: "/",
  },
  {
    name: "About",
    icon: InfoIcon,
    link: "/about",
  },
  {
    name: "Skills",
    icon: GrainIcon,
    link: "/skills",
  },
  {
    name: "Projects",
    icon: LibraryBooksIcon,
    link: "/projects",
  },
  {
    name: "Achievements",
    icon: EmojiEventsIcon,
    link: "/achievements",
  },
  {
    name: "Experience",
    icon: BadgeIcon,
    link: "/experience",
  },
  {
    name: "Education",
    icon: SchoolIcon,
    link: "/education",
  },
  {
    name: "Contact",
    icon: ConnectWithoutContactIcon,
    link: "/contact",
  },
];
